var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B966B",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.344 7.679l3.562 3.642 9.5-9.714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.031 8.893v7.286c0 .67-.532 1.214-1.187 1.214H2.78c-.655 0-1.187-.544-1.187-1.214V2.82c0-.67.532-1.214 1.187-1.214H13.47"
  }))));
}
export default SvgIconChecklist;